import React from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
import { useSelector } from "react-redux";

import { Congrats } from "./components/Congrats";
import { Share } from "./components/Share";
import { useBackgroundAssets } from "helper";

const modalContent = {
  congrats: <Congrats />,
  share: <Share />,
};

export const Modals = () => {
  const { popup_open, popup_type } = useSelector((state) => state.modal);

  return (
    <Modal
      classNames={{
        modal: "main-modal",
      }}
      open={popup_open}
      animationDuration={500}
      center
      focusTrapped={false}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      blockScroll={false}
      showCloseIcon={false}
      styles={{
        modal: useBackgroundAssets("dialog", "100% 100%"),
      }}
    >
      {modalContent[popup_type]}
    </Modal>
  );
};
